import {AchievementName, sortAchievementName} from "./AchievementName";
import {Comparator} from "../../../types/GenericTypes";

export type AchievementStates = ReadonlyArray<AchievementState>;

export interface AchievementState {
    readonly name: AchievementName;
    readonly unlocked: boolean;
    readonly value: number;
}

export function sortStates(): Comparator<AchievementState> {
    const nameSort = sortAchievementName();
    return (a, b) => nameSort(a.name, b.name)
}
